<app-header-simple [title]="'colapp'" [hidden]="loading"></app-header-simple>

<ion-content [hidden]="loading">
  <ion-refresher slot="fixed" (ionRefresh)="onRefreshPage($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <app-header-name></app-header-name>

  <app-credits
    [user]="user"
    [updateCredits]="updateCredits"
    [showBlocked]="true"
  >
  </app-credits>
  <section>
    <a class="item" routerLink="/home/feed/transfer">
      <ion-img
        [src]="'assets/icon/home/transfer.png'"
        [alt]="'Transferir'"
      ></ion-img>
      Transferências
    </a>
    <a class="item" routerLink="/home/feed/pay">
      <ion-img [src]="'assets/icon/home/pay.png'" [alt]="'Pagar'"></ion-img>
      Pagamentos
    </a>

    <a class="item" routerLink="/home/feed/lending">
      <ion-img
        [src]="'assets/icon/home/lend.png'"
        [alt]="'Enviar Recompensa'"
      ></ion-img>
      Empréstimos
    </a>

    <a class="item" routerLink="/home/feed/recurrent">
      <ion-img
        [src]="'assets/icon/home/recurrent.png'"
        [alt]="'Menu de recorrentes'"
      ></ion-img>
      Recorrentes
    </a>

    <a class="item" [hidden]="!user.isCompany" routerLink="/home/feed/receive">
      <ion-img
        [src]="'assets/icon/home/receive.png'"
        [alt]="'Receber'"
      ></ion-img>
      Receber
    </a>

    <a [hidden]="!user.isCompany" class="item" routerLink="/home/feed/cashback">
      <ion-img
        [src]="'assets/icon/home/cashback.png'"
        [alt]="'Enviar Recompensa'"
      ></ion-img>
      Recompensas
    </a>
  </section>
  <div class="footer">
    <div class="footer-indicate" routerLink="/home/feed/indicated">
      <div class="footer-indicate-title">
        <h2>Indique o <span>COLAPP</span></h2>
        <div class="footer-indicate-btn" color="secondary">INDICAR</div>
      </div>
      <ion-img
        [alt]="'Indicações'"
        [src]="'assets/images/indicate/indicate.png'"
      />
    </div>
    <div class="footer-investiment" routerLink="/home/feed/investment">
      <div class="footer-investiment-icon">
        <ion-img
          [alt]="'Investimentos'"
          [src]="'assets/icon/home/investiment.png'"
        />
      </div>
      <div class="footer-investiment-text">
        <div>
          <h3>Investimentos</h3>
          <h4>Produtos pensados para você!</h4>
        </div>
        <div>
          <h3>></h3>
        </div>
      </div>
    </div>
    <div class="footer-partners" routerLink="/home/feed/partners">
      <h2>Conheça quem faz parte do Ecossistema COLAPP</h2>
      <img alt="Investimentos" src="assets/images/partners/partners.png" />
      <h3>></h3>
    </div>
    <div class="footer-donation">
      <div class="footer-donation-title">
        <h2>Ajude o <span>RIO GRANDE DO SUL!</span></h2>
        <div
          class="footer-donation-btn"
          (click)="openModalDonations = true"
          color="secondary"
        >
          Saiba+
        </div>
      </div>
      <ion-img
        (click)="openModalDonations = true"
        [alt]="'Doações'"
        [src]="'assets/images/donations/donations.png'"
      />
    </div>
  </div>
</ion-content>

<ion-modal class="ion-modal-donations" [isOpen]="openModalDonations">
  <ng-template>
    <app-header-simple
      [title]="'colabora'"
      [hidden]="loading"
      [showBtnBack]="true"
      (evtGoBack)="openModalDonations = false; setShowDonations()"
    ></app-header-simple>

    <ion-content>
      <div class="content">
        <div class="header">
          <img src="assets/images/donations/donations.png" alt="" />
        </div>
        <div class="main">
          <h1>Bora Colaborar?</h1>

          <h2>O Rio Grande do Sul precisa da nossa ajuda!</h2>
          <h2>
            Centenas de milhares de pessoas estão sendo afetadas pelas
            <span>enchentes no Rio Grande do Sul.</span>
          </h2>
          <h2>
            A <span>Colapp Networks</span> lança em apoio a campanha
            "#COLABORA", um fundo para auxiliar na reconstrução das áreas
            afetadas pela catástrofe.
          </h2>
          <h2>
            <span
              >Doe qualquer valor para ”#COLABORA” via PIX e estes valores serão
              destinados para compra de materiais de apoio para os desabrigados
              e na reconstrução do Estado.</span
            >
          </h2>
        </div>

        <div class="footer">
          <ion-button color="secondary" (click)="openModalDonateNow = true"
            >DOE AGORA</ion-button
          >
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal class="ion-modal-donate-now" [isOpen]="openModalDonateNow">
  <ng-template>
    <app-header-simple
      [title]="'faça sua doação'"
      [hidden]="loading"
      [showBtnBack]="true"
      (evtGoBack)="openModalDonateNow = false; setShowDonations()"
    ></app-header-simple>

    <ion-content>
      <div class="content">
        <div class="header">
          <h1>Escanei o QRcode e faça parte dessa corrente do bem!</h1>
        </div>
        <div class="main">
          <img src="assets/images/donations/pix.png" alt="" />
        </div>
        <div class="footer">
          <ion-button (click)="onClickCopy()" color="secondary"
            >Copiar código</ion-button
          >
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
